<div class="container">
    <h1>Deseja realmente deletar este produto?</h1>
    <p>Esta operação não pode ser desfeita.</p>
    
    <div>
        <app-regular-button [title]="'Cancelar'" (click)="close()" [secondary]="true"></app-regular-button>
        <app-regular-button [title]="'Deletar'" (click)="delete()"></app-regular-button>
    </div>
</div>